import React, { useEffect, useState, Fragment } from 'react';
import { connect } from 'react-redux';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

import './login.css';


const Login = ( { login } ) => {
    const [ email, setEmail ] = useState( '' );
    const [ pwd, setPwd ] = useState( '' );
    const [ clicked, setClicked ] = useState( false );
    const [ loginButton, setLoginButton ] = useState( 'Login' );
    const [ show, setShow ] = useState( false );
    const [ gotIn, letIn ] = useState( true );
    
    useEffect( () => {
        document.title = 'Third Floor - Login';
    }, [] );

    useEffect( () => {
        if ( !gotIn ) {
            alert( 'Invalid email/password combination - please try again.' );
            setClicked( false );
            setLoginButton( 'Login' );
            letIn( true );
        }
    }, [ gotIn ] );

    const runLogin = async ( e ) => {
        e.preventDefault(); 
        setClicked( true );
        setLoginButton( 'Processing...' );
        const resp = await login( { email: email, pwd: pwd } );
        letIn( resp );
    };

    return (
        <Container fluid className='p-0' style={ { height: 'calc(100vh - 95px)' } }>
            <Row className='tf-page-container justify-content-md-center align-items-center' style={ { height: 'calc(100% - 30px)' } }>
                <Col xs={3} className='p-0'>
                    <Form onSubmit={runLogin}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label className='tf-login-label'>Email</Form.Label>
                            <Form.Control className='tf-login-input' type="email" placeholder="Enter email address" onChange={ ( e ) => setEmail( e.target.value ) } value={email} />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label className='tf-login-label'>Password</Form.Label>
                            <InputGroup>    
                                <Form.Control className='tf-login-input' type={ show ? 'text' : 'password' } placeholder="Enter your password" onChange={ ( e ) => setPwd( e.target.value ) } value={pwd} />
                                <InputGroup.Text onClick={ () => setShow( !show ) } style={ { cursor: 'pointer' } }>{ show ? <FaEyeSlash /> : <FaEye /> }</InputGroup.Text>
                            </InputGroup>
                        </Form.Group>
                        <Button type="submit" disabled={clicked}>
                            {loginButton}
                        </Button>
                    </Form>
                </Col>
            </Row>
        </Container>
    )
}

const mapProps = ( state ) =>( {
    // isLoggedIn: state.user.password
} );

const mapDispatch = ( dispatch ) => ( {
    login: dispatch.user.login
} );

export default connect( mapProps, mapDispatch )( Login );